import { DatePicker as AntdDatePicker } from "antd";
import { useSelector } from "react-redux";
import locale from "antd/es/date-picker/locale/ar_EG";
import DateTime from "utils/dateTime";
import dayjs from "dayjs";
import { Skeleton } from "..";
const range = (start, end) => {
  const result = [];
  for (let i = start; i < end; i++) {
    result.push(i);
  }
  return result;
};
const disabledFutureTime = (date) => {
  if (date) {
    if (
      date?.format("YYYY-MM-DD") === DateTime.formatDate(null, "YYYY-MM-DD")
    ) {
      return {
        disabledHours: () => range(DateTime.getCurrentHour() + 1, 24),
        disabledMinutes: () => range(DateTime.getCurrentMinutes(), 60),
      };
    }
  }
  return {};
};

const disabledPastTime = (date) => {
  if (date) {
    const currentMoment = DateTime.currentTime();
    if (DateTime.isSameDay(date, currentMoment)) {
      return {
        disabledHours: () => range(0, DateTime.getCurrentHour()),
        ...(DateTime.getHourFromDate(date) === DateTime.getCurrentHour() && {
          disabledMinutes: () => range(0, DateTime.getCurrentMinutes()),
        }),
      };
    }
    return {
      disabledHours: () => range(0, 0),
      disabledMinutes: () => range(0, 0),
    };
  }
  return {};
};

function disableDateRanges(range = { startDate: false, endDate: false }) {
  const { startDate, endDate } = range;
  return function disabledDate(current) {
    if (DateTime.isSameDay(endDate, current)) {
      if (
        DateTime.getHourFromDate(current) >= DateTime.getHourFromDate(endDate)
      ) {
        return false;
      }
    }
    let startCheck = true;
    let endCheck = true;
    if (startDate) {
      startCheck = current.isBefore(DateTime.getDateAndTime(startDate), "day");
    }
    if (endDate) {
      endCheck = current.isAfter(DateTime.getDateAndTime(endDate), "day");
    }
    return (startDate && startCheck) || (endDate && endCheck);
  };
}

const disabledDateFuture = (date) => {
  return date && DateTime.isAfterCurrentDay(date);
};

const disabledDatePast = (date) => {
  return date && DateTime.isBeforeCurrentDay(date);
};

const DatePicker = (props) => {
  const {
    disableFuture,
    disablePast,
    range: daterange,
    disableFutureTime,
    disablePastTime,
    disableTimeRange,
    showTime = true,
    onChange,
    skeletonLoading,
    ...rest
  } = props;
  const { locale: appLanguage } = useSelector((state) => state.app.configs);
  return skeletonLoading ? (
    <Skeleton type="input" active height={22} block />
  ) : (
    <AntdDatePicker
      disabledDate={
        !!disableFuture
          ? disabledDateFuture
          : !!disablePast
          ? disabledDatePast
          : !!daterange
          ? disableDateRanges(daterange)
          : null
      }
      showTime={showTime ? { hideDisabledOptions: true } : false}
      inputReadOnly
      disabledTime={
        !!disableFutureTime
          ? disabledFutureTime
          : !!disablePastTime
          ? (date) => disabledPastTime(date, rest.value)
          : !!disableTimeRange
          ? (date) => disableTimeRange(date, daterange, range)
          : null
      }
      onChange={(date) =>
        disablePast && DateTime.isBeforeCurrentDateAndTime(date)
          ? onChange(dayjs())
          : onChange(date)
      }
      // locale={appLanguage === "en" ? [] : locale}
      {...rest}
    />
  );
};

export default DatePicker;
